<template>
<div class="about">
    <div class="paragraph">
        <p>Hi! I'm <span class="name">Susie Ward,</span>
          a passionate front-end developer based in Nashville, TN.</p>
        <p>I specialize in building SEO-friendly single-page web apps and RESTful APIs from the ground up.</p>

        <p>Work portfolio coming soon.<br>
            In the meantime, <a href="mailto:hello@susieward.dev"><span class="name" id="link">get in touch.</span></a>
        </p>
    </div>

</div>

</template>
<script>
export default {
name: 'About'
}
</script>
<style>

.about {
grid-area: about;
display: grid;
justify-content: flex-start;

align-content: center;
margin-bottom: 4px;
width: 100vw;
max-height: 100vh;
background-color:  #f0bfb3;
}

    .about a {
    border-bottom: none;
    }

.paragraph {
grid-area: p;
width: 600px;
min-width: auto;
font-size: 28px;
line-height: 46px;
letter-spacing: 0.02em;
color: #fff;
padding-left: 65px;
padding-top: 30px;
padding-right: 20px;
padding-bottom: 30px;
font-weight: 300;

}

.icons {
grid-area: icons;
display: grid;
grid-template-columns: auto auto;
grid-gap: 15px;
border: 1px solid #444;
align-content: flex-start;
justify-content: flex-end;
padding-top: 15px;
padding-right: 25px;
}

.about-email {
  color: #fff;
}
.mbri-letter {
font-size: 22px;
padding: 0;

    }


    .github-icon {
    height: 22px;
    width: 22px;
    }

    .github {
        border: none;
    }


    .mbri-github {
        color: #555;
font-size: 28px;
margin: auto;
padding: 0;
    }




    .name {
    display: inline-block;
    background-color: #fff;
    color:  #F08080;

    margin-right: 2px;
    margin-left: 2px;
    padding:2px 9px;
    }


    #link {
    background-color: #fff;
        color: #F08080;
        transition: 0.3s;
    }

    #link:hover {
    background-color: #F08080;
    color: #fff;
    }

@media screen and (max-width: 700px){


    .paragraph {
max-width: 450px;
min-width: auto;
font-size: 23px;
    line-height: 30px;
letter-spacing: 0.02em;


}
}


@media screen and (max-width: 400px){
    .paragraph {
max-width: 350px;
min-width: auto;
font-size: 20px;
line-height: 30px;
letter-spacing: 0.02em;
padding: 20px;


}
}
</style>
